import { createStyles, rem } from '@mantine/core';
import theme from './theme';

export const useStyles = createStyles((theme) => ({
  card: {
    height: rem(70),
    width: rem(70),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '1px solid #FAC214',
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontWeight: 900,
    color: theme.white,
    lineHeight: 1.2,
    fontSize: rem(32),
    marginTop: theme.spacing.xs,
  },

  category: {
    color: theme.white,
    opacity: 0.7,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
}));

export const leftSideStyle = createStyles((theme) => ({
  sideBar: {
    position: 'relative',
    '&::after': {
      content: `""`,
      position: 'absolute',
      width: 150,
      height: '75vh',
      borderRadius: '0px 0px 251px 0px',
      top: -85,
      left: 0,
      zIndex: -1,
    },
  },
  webSideBar: {
    position: 'relative',
    '&::after': {
      content: `""`,
      position: 'fixed',
      width: 170,
      height: '96vh',
      borderRadius: '0px 0px 125px 0px',
      top: -85,
      left: 0,
      zIndex: -1,
    },
  },
  textStyle: {
    fontSize: 11,
  },

  toastContainer: {
    width: '90%',
    right: '0%',
    left: '10%',
    '.Toastify__progress-bar--success': {
      backgroundColor: theme.colors.yellow[6],
    },
    svg: {
      fill: theme.colors.yellow[6],
    },
  },
  navLogo: {
    '@media(max-width:480px)': {
      flexDirection: 'column',
      paddingLeft: '0px',
    },
  },
  navLinks: {
    '@media(max-width:360px)': {
      gap: '14px',
    },
  },
  groupCenter: {
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%,-50%)',
    '@media print': {
      display: 'none',
    },
  },
  horizontalNav: {
    position: 'relative',
    padding: '8px 14px',
    borderRadius: '10px',
    fontWeight: 500,
    color: theme.colors.gray[7],
    transition: 'all 150ms ease',

    '&:hover, &.active': {
      backgroundColor: 'rgba(252, 207, 73, 0.5)',
      color: theme.colors.yellow[7],
      transform: 'translateY(-1px)',
    },
    '@media(max-width:480px)': {
      display: 'none',
    },
  },
}));

export const rightSideStyle = createStyles(() => ({
  rightSideBar: {
    position: 'relative',
    '&::after': {
      content: `""`,
      position: 'absolute',
      width: 154,
      height: '16vh',
      background: theme.colors?.yellow?.[6],
      borderRadius: '0px 0px 251px 0px',
      top: 0,
      left: '260px',
      zIndex: -1,
      transform: 'matrix(-1, 0, 0, 1, 0, 0)',
    },
  },
  rightSideWeb: {
    position: 'relative',
    '&::after': {
      content: `""`,
      position: 'fixed',
      width: 154,
      height: '150px',
      background: theme.colors?.yellow?.[6],
      borderRadius: '0px 0px 251px 0px',
      top: 0,
      right: 0,
      zIndex: -1,
      transform: 'matrix(-1, 0, 0, 1, 0, 0)',
    },
  },
}));

export const webFontStyle = createStyles(() => ({
  extraSmallText: {
    fontSize: '13px',
  },
  smallText: {
    fontSize: '15px',
  },
  mediumText: {
    fontSize: '16px',
  },
}));

export const buttonStyle = createStyles(() => ({
  buttonShadow: {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.20)',
    '@media print': {
      display: 'none',
    },
  },
}));
